module.exports = __webpack_public_path__ + "img/14.b0a5f6fd.png";